import React, { useEffect, useState } from "react";
import TicketView from "./TicketView";
import { useNavigate, useParams } from "react-router-dom";
import { getBookingById } from "../../../Redux/Apis/User-Apis";
import { useSelector } from "react-redux";
import { getLocalStorageJSON } from "../../../Utils/localStorageFunc";
import toast from "react-hot-toast";
import Header from "../../Components/Headers/Header";
import Footer from "../../Components/Footers/Footer";
import BookingSideBar from "./Components/BookingSideBar";
import { Box, CircularProgress, Typography } from "@mui/material";

function FlightBooking() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [bookingData, setBookingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { isUserLogin } = useSelector((state) => state.user);

  useEffect(() => {
    const getBookingData = async () => {
      try {
        const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
        const response = await getBookingById(id, token);

        if (!response.error) {
          setBookingData(response.data.booking);
        } else {
          toast.error("Failed to fetch booking data.");
          navigate("/");
        }
      } catch (error) {
        toast.error("Something went wrong.");
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    getBookingData();
  }, [id, isUserLogin, navigate]);

  console.log("bookingData inside single booking is : " , bookingData);
  
  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        textAlign="center"
      >
        <CircularProgress size={60} />
        <Typography variant="h6" mt={3} color="text.secondary">
          Please wait while we fetch your booking details...
        </Typography>
      </Box>
    );
  }

  if (
    !bookingData?.ExpandData ||
    !bookingData?.ExpandData?.TicketViewData
  ) {
    toast.error("No Ticket Data Made for This Flight");
    navigate("/user/myflightbookings");
    return null;
  }

  return (
    <>
      <Header />
      <div className="user-panel proxima_regular">
        <div className="aside-main">
          <BookingSideBar SidebarOptions={bookingData?.ExpandData.SideBarOptions} />
          <div className="userdb-content">
            <TicketView Data={bookingData?.ExpandData.TicketViewData.data} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default FlightBooking;
